export const EPF_CONTRIBUTION_TYPE = {
  MANDATORY_ONLY: {
    label: "Yes, I do mandatory contribution only",
    value: "MANDATORY_ONLY",
  },
  MANDATORY_AND_VOLUNTARY: {
    label: "Yes, I do both mandatory and voluntary contribution",
    value: "MANDATORY_AND_VOLUNTARY",
  },
  NO_ACTIVE_CONTRIBUTION: {
    label: "No, I do not actively contribute towards my EPF",
    value: "NO_ACTIVE_CONTRIBUTION",
  },
};

export const RACE_TYPE = {
  MALAY: "Malay",
  CHINESE: "Chinese",
  INDIAN: "Indian",
  OTHERS: "Others",
};
